import React from 'react';
import Stats from './pages/Stats/Stats';
// import Tut from './components/Visualizations/Tut/Tut';
// import BarChart from './components/Visualizations/Tut/BarChart';

const App = () => {
  return <Stats />;
  // return <BarChart />;
};

export default App;